module.exports = __webpack_public_path__ + "img/serviceGuide-center-5.2a66307.png";